export interface IPendingItem {
  id: string;
  description: string;
}

export interface IStatusState {
  isPending: boolean;
  items: Array<IPendingItem>;
  description?: string;
}

export const ADD_PENDING = "STATUS_ADD_PENDING";
export const COMPLETE_PENDING = "STATUS_COMPLETE_PENDING";

export type ActionTypes = typeof ADD_PENDING | typeof COMPLETE_PENDING;

export interface IStatusAction {
  type: ActionTypes;
  item: IPendingItem;
}
